import { Reveal } from "../../lib/motion";
import { BOOK } from "../../data/content";
import { BuyButton, Ornament } from "./ui";

export function FinalCTA() {
  return (
    <section className="relative py-28 sm:py-44 bg-secondary overflow-hidden" data-testid="final-cta" data-section="final-cta" data-section-label="Call to action finale">
      <div
        className="absolute inset-0 opacity-[0.12] pointer-events-none"
        style={{ background: "radial-gradient(ellipse at 50% 100%, #aa8656 0%, transparent 60%)" }}
      />
      <div className="relative max-w-3xl mx-auto px-5 sm:px-10 text-center">
        <Reveal>
          <img
            src={BOOK.coverUrl}
            alt="Self Doubling book cover"
            className="w-40 sm:w-48 mx-auto rounded-md ring-1 ring-[var(--gold-line)] shadow-[0_30px_60px_-20px_rgba(0,0,0,0.9)] mb-12"
          />
        </Reveal>
        <Reveal delay={0.05}>
          <Ornament className="mb-8" />
        </Reveal>
        <Reveal delay={0.1}>
          <p className="label mb-4">The Book</p>
          <h2 className="font-editorial italic text-3xl sm:text-5xl text-cream leading-tight">
            The Truth That Dwells Within You
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="font-body font-light text-secondary mt-6 text-lg">
            225 pages · by Maria Gioia Mosca
          </p>
        </Reveal>
        <Reveal delay={0.25}>
          <div className="mt-8 mx-auto max-w-xl gold-border rounded-2xl px-6 py-5 bg-[rgba(170,134,86,0.06)]">
            <p className="label mb-2">A gift for every reader</p>
            <p className="font-editorial italic text-lg sm:text-xl text-gold-light leading-snug">
              Everyone who buys the book is invited to an exclusive online meeting with the
              author, Maria Gioia Mosca, who will personally answer your questions.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-10">
            <BuyButton location="final" size="lg" testId="buy-btn-final" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
